import { useEffect, useState } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildAccountCompaniesRequest } from './utils';

const useGetAccountCompanies = (filterActiveCompanies) => {
  const [accountCompanies, setAccountCompanies] = useState([]);
  const [debouncedCompanyInput, setDebouncedCompanyInput] = useState('');
  const accountId = useCurrentAccountId();

  const {
    data: accountCompaniesData,
    loading: isFetchingAccountCompanies,
    doFetch: doGetAccountCompanies,
  } = useDataApi();

  const handleCompanyInputChange = (companyInput) => {
    setDebouncedCompanyInput(companyInput);
  };

  useEffect(() => {
    if (!accountId) return;

    doGetAccountCompanies(
      buildAccountCompaniesRequest(accountId, debouncedCompanyInput)
    );
  }, [debouncedCompanyInput, accountId, doGetAccountCompanies]);

  useEffect(() => {
    if (!accountCompaniesData) return;

    const { results } = accountCompaniesData;
    const companies = filterActiveCompanies
      ? results?.filter((company) => company.status === 'active') || []
      : results;
    setAccountCompanies(companies);
  }, [accountCompaniesData, filterActiveCompanies]);

  return {
    accountCompanies,
    onChangeCompanyInput: handleCompanyInputChange,
    isFetchingAccountCompanies,
  };
};

export default useGetAccountCompanies;
